export enum enumDocumentRootEntityType {
  ENTRY_SUMMARY,
  SHIPMENT,
  INVOICE,
  LINE_ITEM,
  COMPANY,
  USER,
  ISF,
  DELIVERY_ORDER,
  BOND_REQUEST,
  FREIGHT_SHIPMENT,
  ENTITY,
  CONTAINER,
  STATEMENT,
  PRICE_LIST,
  MARINE_INSURANCE_SHIPMENT,
  ORGANIZATION,
  BILL,
  BILL_INVOICE,
}
